import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

const TSPM_API = "https://tspm-api.abrandfantastic.workers.dev";

const CMS_DEFAULTS = {
  lol_ty_headline: "One more step",
  lol_ty_subtext:  "We've sent a confirmation email to your inbox.\nClick the link inside to secure your spot.",
  lol_ty_message:  "No confirmation, no spot.\nCheck your inbox — it should be there now.",
};

export default function ThankYouPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const name = location.state?.name || "Friend";
  const [cms, setCms] = useState(CMS_DEFAULTS);

  useEffect(() => {
    fetch(`${TSPM_API}/api/site-content`)
      .then(r => r.json())
      .then(data => setCms(c => ({ ...c, ...Object.fromEntries(Object.keys(CMS_DEFAULTS).map(k => [k, data[k] ?? c[k]])) })))
      .catch(() => {});
  }, []);

  return (
    <div className="thankyou-page" data-testid="thankyou-page">
      {/* Top Marquee - matching shop style */}
      <div className="top-marquee thankyou-marquee-top" data-testid="top-marquee">
        <div className="marquee-track">
          {[...Array(10)].map((_, i) => (
            <span key={i} className="marquee-item">
              THANK YOU &nbsp; ✦ &nbsp; YOU'RE ON THE LIST &nbsp; ✦ &nbsp; REVIVE LOLLIPOP &nbsp; ✦ &nbsp;
            </span>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <main className="thankyou-main">
        <div className="thankyou-container">
          <motion.div 
            className="stamp-wrapper"
            initial={{ scale: 0, rotate: -45 }}
            animate={{ scale: 1, rotate: -8 }}
            transition={{ type: "spring", stiffness: 300, damping: 15, delay: 0.2 }}
            data-testid="revived-stamp"
          >
            <div className="stamp">REVIVED</div>
          </motion.div>

          <motion.h1
            className="thankyou-headline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            data-testid="thankyou-headline"
          >
            {cms.lol_ty_headline}, {name}
          </motion.h1>

          <motion.p
            className="thankyou-subtext"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            data-testid="thankyou-subtext"
          >
            {cms.lol_ty_subtext.split('\n').map((line, i, arr) => (
              <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
            ))}
          </motion.p>

          <motion.div
            className="message-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <p className="message-text">
              {cms.lol_ty_message.split('\n').map((line, i, arr) => (
                <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
              ))}
            </p>
          </motion.div>

          <motion.button
            className="back-btn"
            onClick={() => navigate("/")}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            data-testid="back-button"
          >
            <ArrowLeft size={18} />
            <span>Back to waitlist</span>
          </motion.button>
        </div>
      </main>

      {/* Bottom brand bar */}
      <div className="bottom-bar" data-testid="bottom-bar">
        <div className="bottom-marquee">
          {[...Array(10)].map((_, i) => (
            <span key={i} className="bottom-item">
              LOLLIPOP + POPSICLE &nbsp; &nbsp;
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
